import { cn } from '@helpers/cn';

import { TProps } from './types/TProps';

export const ModalFooter = ({ children, className }: TProps) => (
  <div className={cn('modal-footer', className)}>{children}</div>
);
